<div class="navbar-branding">
  <!-- <mat-icon class="brand-logo" svgIcon="angular-logo"></mat-icon> -->
  <img src="assets/man-insights.svg" height="40px;" alt="Man Insights">
</div>

<div class="navbar-actions">
  <button type="button" class="action-button btn btn-link">
    <mat-icon class="navbar-icons" svgIcon="settings"></mat-icon>
  </button>
  <button type="button" class="action-button btn btn-link">
    <mat-icon class="navbar-icons" svgIcon="notifications"></mat-icon>
  </button>
  <button type="button" class="action-button btn btn-link">
    <mat-icon class="navbar-icons" svgIcon="search"></mat-icon>
  </button>
</div>
